module.exports = __webpack_public_path__ + "mu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mu.svg
// module id = 964
// module chunks = 0